import { buscarRegrasPorPlano } from '../dependentesv2/regrasPorPlano';
import { calcularIdade } from '../dependentesv2/helpers/funcoesAuxiliares';
import { regrasPorPlanoValidateOnSubmit } from '../dependentesv2/regrasPorPlanoOnSubmit';

export class ValidacaoDependenteEditarContrato {
    constructor(planoAtual,planoFuturo,dependentes,dadosAssociado) {
        this.planoAtual = planoAtual;
        this.planoFuturo = planoFuturo;
        this.dependentes = dependentes;
        this.dadosAssociado = dadosAssociado;
    }

    async validarTroca () {
        const arrayDepControle = [];
        const arrayMsgErroControle = new Set();
        const idadeAssociado = calcularIdade(this.dadosAssociado.Nascimento);

        for (const dependente of this.dependentes) {
            const virtualValueForm = this.makeVirtualValueForm(dependente);
            const arrayMsgErroOnSubmit = await regrasPorPlanoValidateOnSubmit(arrayDepControle,this.planoFuturo,virtualValueForm,false);
            
            const arrayMsgErroReativa = await buscarRegrasPorPlano(this.planoFuturo,arrayDepControle,virtualValueForm.Parentesco,[],virtualValueForm,false,{},true,idadeAssociado);
            const arrayMsgErro = [...arrayMsgErroOnSubmit,...arrayMsgErroReativa];

            if(arrayMsgErro.length > 0){
                arrayMsgErroControle.add(...arrayMsgErro);
            }else{
                arrayDepControle.push(virtualValueForm);
            }
        }

        return  Array.from(arrayMsgErroControle);
    }

    makeVirtualValueForm (dependente) {
        return {
            CPF : dependente.CPF,
            'CategoriaParentesco.Categoria': dependente['CategoriaParentesco.Categoria'], 
            Categoria:dependente['CategoriaParentesco.Categoria'],
            DepSexo:dependente.DepSexo,
            Email:dependente.Email,
            Idade: dependente.Idade,
            Nascimento: dependente.Nascimento,
            Nome : dependente.Nome,
            'GrauParentesco.Grau': dependente['GrauParentesco.Grau'],
            Parentesco: dependente['GrauParentesco.Grau'],
            Telefone:dependente.Parentesco
        };
    }
}
export default ValidacaoDependenteEditarContrato;
